import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Ai4HerPlacardPage from './pages/Ai4HerPlacardPage';
import AI4HERProgramPage from './pages/AI4HERProgramPage';
import AI4HERHubPage from './pages/AI4HERHubPage';
import AI4HERIWD2026Page from './pages/AI4HERIWD2026Page';
import AboutPage from './pages/AboutPage';
import DivisionsPage from './pages/DivisionsPage';
import GovernancePage from './pages/GovernancePage';
import FacultyPage from './pages/FacultyPage';
import CharterPage from './pages/CharterPage';
import NewsPage from './pages/NewsPage';
import ColumnPage from './pages/ColumnPage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import PhilosophyPage from './pages/PhilosophyPage';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <Router basename="">
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/ai4her" element={<AI4HERHubPage />} />
          <Route path="/ai4her-waitalk" element={<AI4HERProgramPage />} />
          <Route path="/ai4her-iwd2026" element={<AI4HERIWD2026Page />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/divisions" element={<DivisionsPage />} />
          <Route path="/governance" element={<GovernancePage />} />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/charter" element={<CharterPage />} />
          <Route path="/column" element={<ColumnPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/philosophy" element={<PhilosophyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
